import {Link} from 'react-router';
import {tr, trx, txt} from '../i18n/idioma';

// Configuracion de campos: las listas que definen como se llenan o se
// interpretan columnas de la app (decision de Daniel, 28/09/2026). Cada lista
// es una tarjeta; las nuevas se agregan aqui.
const LISTAS = [
  {
    a: '/configuracion-de-campos/prefijos',
    titulo: txt('Exportadores por prefijo', 'Exporters by prefix'),
    descripcion: txt(
      'A qué exportador corresponde cada prefijo del código de exportación (por ejemplo GLC → el exportador de las GLC-01, GLC-02…). Se usa en las exportaciones de terceros, que no traen exportador en el archivo de seguimiento.',
      'Which exporter each export-code prefix belongs to (for example GLC → the exporter of GLC-01, GLC-02…). Used for third-party exports, which have no exporter in the tracking file.',
    ),
  },
  {
    a: '/configuracion-de-campos/empresas',
    titulo: txt('Empresas y otros nombres', 'Companies and other names'),
    descripcion: txt(
      'Todas las empresas (exportadores, proveedores, navieras…) con sus otros nombres. Si una aparece repetida con otro nombre (por ejemplo "CM" por Colombian Mint), se une con la correcta y ese nombre queda reconocido para las próximas cargas.',
      'All companies (exporters, suppliers, shipping lines…) with their other names. If one appears repeated under another name (for example "CM" for Colombian Mint), merge it into the right one and that name is recognised in future uploads.',
    ),
  },
  {
    a: '/configuracion-de-campos/financiadores',
    titulo: txt('Financiadores y cupos', 'Financers and credit lines'),
    descripcion: txt(
      'El nombre de cada financiador (BLQ, carta de crédito, crédito bancario, venta directa) y su cupo en dólares. Con el cupo, la pestaña Financiaciones muestra cuánto queda disponible.',
      'Each financer name (BLQ, letter of credit, bank credit, direct sale) and its credit line in dollars. With the line, the Financing tab shows how much is left.',
    ),
  },
];

export function PaginaConfiguracionDeCampos() {
  return (
    <section className="max-w-4xl space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-verde-oscuro">{tr('Configuración de campos', 'Field settings')}</h1>
        <p className="text-sm text-apagado">
          {tr(
            'Listas que definen cómo se llenan o se interpretan algunas columnas de la app. Los cambios quedan en la bitácora.',
            'Lists that define how some columns of the app are filled in or interpreted. Changes are kept in the audit log.',
          )}
        </p>
      </div>
      <ul className="grid gap-3 sm:grid-cols-2">
        {LISTAS.map(l => (
          <li key={l.a}>
            <Link
              to={l.a}
              className="block h-full rounded-lg border border-linea bg-white p-4 hover:border-verde hover:bg-papel"
            >
              <div className="font-medium text-verde-oscuro">{trx(l.titulo)}</div>
              <p className="mt-1 text-sm text-apagado">{trx(l.descripcion)}</p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
